module.exports = __webpack_public_path__ + "files/c3e0afb6926e4391b6628e8c2228c639.png";